import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';

type PricingAverageRequest = {
    category: string;
    experienceLevel: string;
    countryCode: string;
};

export type PricingAverageResponse = {
    minPrice: number;
    maxPrice: number;
};

export class PricingStatService {
    async getAverage(request: PricingAverageRequest): Promise<HttpServiceResponse<PricingAverageResponse>> {
        return await context.httpService.post(context.registry.entries.priceStats(), request);
    }
}
